import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStoreService } from '../services/local-store.service';
import { AngularFireAuth } from '@angular/fire/auth';
import { take, switchMap } from 'rxjs/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  token: string;

  constructor(
    private store: LocalStoreService,
    private auth: AngularFireAuth
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.auth.idToken.pipe(
      take(1),
      switchMap((token: any) => {
        if (token) {
          request = request.clone({
            setHeaders: { Authorization: `Bearer ${token}`, "x-racebet-sec": "b07d7900017e89e89c9b770e71c7d4a2" }
          });
        } else {
          request = request.clone({
            setHeaders: { "x-racebet-sec": "b07d7900017e89e89c9b770e71c7d4a2" }
          });
        }
        return next.handle(request);
      })
    );
  }
}
